<template>
  <div class="FileDownloadBtn">
    <button @click="downloadPdf">{{ buttonLabel }}</button>
  </div>
</template>

<script>
export default {
  name: 'DownloadPdfButton',
  props: {
    pdfUrl: {
      type: String,
      required: true
    },
    pdfFileName: {
      type: String,
      required: true
    },
    // 2. 새로운 Prop 추가
    buttonLabel: {
      type: String,
      default: '소개 자료 다운로드', // 값을 안 넘겨주면 기본적으로 이 텍스트가 나옵니다.
      required: false
    }
  },
  methods: {
    downloadPdf() {
      const link = document.createElement('a');
      link.href = this.pdfUrl;
      link.target = '_blank';
      link.download = this.pdfFileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>